import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from 'vue-property-decorator';
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
let HomeView = class HomeView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.user = null;
    }
    async mounted() {
        let isLoggedIn = await this.authService.isLoggedIn();
        if (isLoggedIn === true) {
            console.log("logged in");
            this.user = await this.authService.getUser();
        }
        else {
            console.log("not logged in");
        }
    }
};
HomeView = tslib_1.__decorate([
    Component({
        name: 'home',
        components: {}
    })
], HomeView);
export default HomeView;
